<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="chap1">ACQUIESCE</p>
<p class="chap_line"></p>
<p class="center"><span class="big"><i>K</i></span>ing Benjamin’s words of counsel to his assembled nation he did address</p>
<p class="center">That like a child’s trust in their father, to God’s will we are to trust and without question or doubt acquiesce.</p>
<p class="center1">For some this is a simple and easy task</p>
<p class="center">But for others, and especially me, this is very arduous because of the decrepit honor of my own father, taints the ability with an accepting heart and to not murmur nor lambast.</p>
<p class="center1">God can, and will, your honor and resolve put to the test</p>
<p class="center">And make no mistake, that for our own good and ability to grow, requires that the imposed travails we must accept and without questioning best.</p>
<p class="center1">Some tests and counsel are easily consumed and put to rest</p>
<p class="center">While others are self-generated mountains that you must daily climb or wrest.</p>
<p class="center1">King Benjamin’s words of counsel to his assembled nation he did address</p>
<p class="center">That like a child’s trust in their father, to God’s will we are to trust and without question or doubt acquiesce.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap002.vue?e2a6ff94